import type {CurrentPage} from 'shared/page/types';
import type {MenuItem} from 'shared/components/kp-main-menu/types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';

export class CurrentPageDataService {
    public static serviceName = 'currentPageDataService';

    public static CURRENT_PAGE_DATA_ROUTE = 'current-page-data';
    public static CURRENT_PAGE_MENU_ITEMS_ROUTE = 'current-page-data/menu';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getCurrentPageData(): Promise<CurrentPage> {
        return this.ajaxService
            .createRequest(CurrentPageDataService.CURRENT_PAGE_DATA_ROUTE)
            .get();
    }

    @ngAsync()
    public async getCurrentPageMenuItems(): Promise<MenuItem[]> {
        return this.ajaxService
            .createRequest(CurrentPageDataService.CURRENT_PAGE_MENU_ITEMS_ROUTE)
            .get();
    }
}